
import AssignForm from '../AssignForm/AssignForm';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingBtn from '../../../components/LoadingBtn/LoadingBtn';
import { useRef, useState } from 'react';
import api from '../../../api/Api';


function AssignAsset() {
  const navigate = useNavigate();
   const formRef = useRef();
   const [loading, setLoading] = useState(false);

  const handleAdd = (data) => {
    setLoading(true);
    api.post("/api/assignments", data)
      .then(() => {
              toast.success("Assign Add Succesfully");
              setTimeout(() => navigate('/assignments'), 1000);
            })
      .catch((err) => console.error(err))
  };

  return (
    <>
    {/* <ToastContainer position="bottom-right" autoClose={3000} /> */}
       <div className='d-flex align-items-center mx-3'>
        <div style={{ width: "200px" }}><Link to="/assets" className="btn btn-secondary mt-3 mb-3">← Back</Link></div>
        <div className="flex-grow-1 text-center"><h3 className='mt-3'>Assign Asset</h3></div>
        <div style={{ width: "200px", textAlign: "right" }}>
          <LoadingBtn
            type="Submit"
            text="Submit"
            loading={loading}
             disabled={loading}
             onClick={() => {
              if (!loading) {
                formRef.current.submitForm();
              }
            }}
          />
        </div>
      </div>
      <div className="container" style={{ width: "900px",height:'450px',overflowY:'auto'}}>
          <AssignForm ref={formRef} onSubmit={handleAdd} isEdit={false}/>
      </div>


    </>
  );
}
export default AssignAsset;